import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quota-upgrade-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quota-upgrade-modal.component.html',
  styleUrl: './quota-upgrade-modal.component.scss'
})
export class QuotaUpgradeModalComponent {
  @Input() show = false;
  @Input() message = '';
  @Output() close = new EventEmitter<void>();

  private router = inject(Router);

  upgrade() {
    this.close.emit();
    this.router.navigate(['/upgrade']);
  }
}
